import React from "react";
import Graphics502 from "../../assets/images/404.svg";

const InternalServerError = () => {
  return (
    <div className="container mx-auto p-4 md:p-8 min-h-[80vh]">
      <div className="flex justify-center items-center w-full h-full min-h-[80vh]">
        <div className="flex items-center flex-wrap sm:flex-nowrap gap-4 max-w-[840px]">
          <div className="w-full sm:w-1/2">
            <h2 className="heading text-[38px] leading-[1.2] font-semibold uppercase mb-2">500 internal server error</h2>
            <p className="mt-4">Please try again later or contact support if the issue persists.</p>
          </div>
          <div className="w-full sm:w-1/2">
            <img src={Graphics502} alt="502 Bad Gateway" className="w-auto h-[280px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalServerError;
